export default __webpack_public_path__ + "static/media/vip-6.bd031c73.svg";